import React from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import HomeHeroImg from '../assets/home.png';

const Home = () => {
    return (
        <>
            {/* Hero Section */}
            <header>
                <section className="banner align-items-center text-center position-relative">
                    <img
                        id="banner-img"
                        src={HomeHeroImg}
                        alt="Speech Innovation NC - Professional Speech Therapy"
                    />
                    {/* Optional overlay text */}
                    {/* <div className="position-absolute top-50 start-50 translate-middle text-white">
            <h1 className="display-4 fw-bold">Speech Innovation NC</h1>
            <p className="lead">Personalized speech therapy in a warm, supportive environment</p>
          </div> */}
                </section>
            </header>
            {/* Hero Content Below Banner */}
            <section className="container text-center py-5">
                <div className="row justify-content-center">
                    <div className="col-lg-8">
                        <h1 className="display-4 fw-bold mb-4 fade-up">
                            Empowering Communication, Transforming Lives
                        </h1>
                        <p className="lead mb-4 fade-up">
                            Professional speech therapy services for children and adults in
                            the Charlotte Metro area. We create personalized treatment plans in a warm,
                            supportive environment where every voice matters.
                        </p>
                        <div className="d-flex gap-3 justify-content-center flex-wrap fade-up">
                            <Link to="/contact" className="btn-cta">
                                Schedule a Consultation
                            </Link>
                            <Link to="/services" className="btn-cta">
                                Explore Services
                            </Link>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Home;
